import { asScaled, getFontFamily } from '../utils';
// 字体尺寸（未缩放）
const fontSizeUnscaled = {
    fontSizeXS: 10,
    fontSizeMS: 11,
    fontSizeS: 12,
    fontSizeM: 14,
    fontSizeL: 16,
    fontSizeXL: 18,
    fontSizeX2L: 20,
    fontSizeX3L: 22,
    fontSizeX4L: 24,
    fontSizeX5L: 28
};
// 字体尺寸（缩放）
const fontSizeScaled = asScaled(fontSizeUnscaled);
const fontWeight = {
    fontWeightRegular: 'normal',
    fontWeightBold: 'bold'
};
// 设置fontFamily
const fontFamily = getFontFamily();
// 字体行高
const lineHeightUnscaled = {
    // 系统字体
    lineHeightT28: 40,
    lineHeightT24: 32,
    lineHeightT22: 30,
    lineHeightT20: 28,
    lineHeightT18: 24,
    lineHeightT16: 22,
    lineHeightT14: 20,
    lineHeightT12: 18,
    lineHeightT11: 16,
    lineHeightT10: 14,
    // 20TH字体
    lineHeightN28: 34,
    lineHeightN24: 30,
    lineHeightN22: 28,
    lineHeightN20: 26,
    lineHeightN18: 22,
    lineHeightN16: 20,
    lineHeightN14: 18,
    lineHeightN12: 16,
    lineHeightN11: 14,
    lineHeightN10: 12
};
const lineHeightScaled = asScaled(lineHeightUnscaled);
const size = {
    unscaled: fontSizeUnscaled,
    scaled: fontSizeScaled
};
const lineHeight = {
    unscaled: lineHeightUnscaled,
    scaled: lineHeightScaled
};
const weight = fontWeight;
const family = fontFamily;
export { size, lineHeight, weight, family };
